/* eslint-disable */


import React, { Component } from 'react'
import { NavigationActions } from 'react-navigation'
import { connect } from 'react-redux'

import { View, TouchableOpacity } from 'react-native'
/*
import { ScrollView, KeyboardAvoidingView, SectionList, Image, Platform, View, ActivityIndicator } from 'react-native'
import VersionNumber from 'react-native-version-number'
import { Images } from '../Themes'

import SectionHeader from '../Components/SectionHeader';
import ListItemTextIcon from '../Components/ListItemTextIcon';
import ListItemArrowIcon from '../Components/ListItemArrowIcon';
import ListItemTextMiddle from '../Components/ListItemTextMiddle';
import BackButtonComponent from '../Components/BackButtonComponent';
import AuthActions from '../Redux/AuthRedux';
import StartupActions from '../Redux/StartupRedux';
import ShoppableActions from '../Redux/ShoppableRedux';
import { Fonts } from '../Themes/'
import API from '../Services/Api'
import FixtureAPI from '../Services/FixtureApi'
import DebugConfig from '../Config/DebugConfig'
import styles from './Styles/SettingsScreenStyle'
import {isIPhoneX} from '../Lib/utils'
*/

import BaseScreen from './BaseScreen'
import MainNavBarScreen from './MainNavBarScreen'
import { Text } from 'native-base';

class BlankScreen extends Component {
  constructor(props) {
    super(props)
  }

  static navigationOptions = {
    header: null
  }

  
  componentDidMount() {

    /*
    this.navigationBar.setRightNavBarButtons([
      { onPress: this.onHumburgerPress, type: 'hamburger' },
    ]) */

    if (this.navigationBar) this.navigationBar.setRightNavBarButtons([ { onPress: this.onHomePress, type: 'home' } ])

  }

  onHomePress = ( ) => {

    /*
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: 'home', params: { isScroll : true } })]
    }))
    */

    console.log("on home press")
    this.props.navigation.goBack()

  }
  onHumburgerPress = () => {
    this.props.screenProps.openDrawer()
  }

  /***
        <MainNavBarScreen
          ref={(view) => {
            if (view) this.navigationBar = view
          }}
  title={`Blank Screen`}
        />
***/

  render() {
    return (
      <View style={{width:'100%', height:'100%'}} darkStatusbar loading={this.props.fetching}>
        <TouchableOpacity style={{top: 100}} onPress={this.onHomePress}>
        <Text>Blank Test Screen : tap to go back</Text>
        </TouchableOpacity>
      </View>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BlankScreen)
